var map = {
	"./cs.json": [
		59694,
		59694
	],
	"./de.json": [
		99727,
		99727
	],
	"./en.json": [
		78967,
		78967
	],
	"./es.json": [
		89728,
		89728
	],
	"./fr.json": [
		95588,
		95588
	],
	"./it.json": [
		52829,
		52829
	],
	"./ja.json": [
		18493,
		18493
	],
	"./ko.json": [
		84930,
		84930
	],
	"./pl.json": [
		8640,
		8640
	],
	"./pt-br.json": [
		39047,
		39047
	],
	"./pt.json": [
		81192,
		81192
	],
	"./ru.json": [
		72305,
		72305
	],
	"./tr.json": [
		33266,
		33266
	],
	"./zh.json": [
		79706,
		79706
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 841;
module.exports = webpackAsyncContext;